import { pipe } from "ramda";
import round from "./round.mjs";
import parseFloat from "./parseFloat.mjs";
const million = Math.pow(10, 10);
export const formatNumeric = (n, { precision } = {}) => {
    // Fix floating point weirdness: .07 * 100 === 7.000000000000001
    n = Math.round(n * 100 * million) / million;
    return String(precision === undefined ? n : parseFloat(n.toFixed(precision)));
};
export const parseNumeric = (display, { precision } = {}) => {
    const result = parseFloat(display) / 100;
    return precision === undefined ? result : round(precision, result);
};
export const format = pipe(formatNumeric, (value) => `${value}%`);
export const parse = (value, opts) => parseNumeric(value.replace("%", ""), opts);
//# sourceMappingURL=percent.mjs.map